import React, { useEffect } from "react";
import {
  Button,
  Row,
  Col,
  ListGroup,
  Image,
  Card,
  Table,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Message from "../components/Message";
import CheckoutSteps from "../components/CheckoutSteps";
import { createOrder } from "../actions/orderActions";
import { ORDER_CREATE_RESET } from "../constants/orderConstants";

function PlaceQuoteScreen({ history }) {
  // CONSTANTS
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const cart = useSelector((state) => state.cart);
  const { cartItems } = cart;

  const cartAdjustments = localStorage.getItem("adjustments")
    ? JSON.parse(localStorage.getItem("adjustments"))
    : [];
  const orderCreate = useSelector((state) => state.orderCreate);
  const { order,  success } = orderCreate;
  const dispatch = useDispatch();
  const { configure } = cart;

  // CALCULATIONS

  // EFFECTS
  useEffect(() => {
    if (!userInfo) {
      history.push("/login");
      return;
    }
    if (cartItems.length === 0 || cartItems.length > 1) {
      history.push("/cart");
      return;
    }
    if (cart.salesProgram.length === 0) {
      history.push("/adjustments");
      return;
    }
    if (!cart.shippingAddress.clientEmail) {
      history.push("/adjustments");
      return;
    }
    if (success) {
      history.push(`/order/${order._id}`);
      dispatch({ type: ORDER_CREATE_RESET });
    }
  }, [success, history, order, dispatch, cartItems, cart, userInfo]);

  // PLACE ORDER
  const placeOrder = () => {
    dispatch(
      createOrder({
        orderItems: cart.cartItems,
        shippingAddress: cart.shippingAddress,
        product_name: cartItems[0].name,
        imageURL: cartItems[0].image,
        t_list_description: configure.t_list_description,
        t_MSRP: configure.t_MSRP,
        setup_pdi: configure.setupPDI,
        a_list_description: configure.a_list_description,
        a_qty: configure.a_qty,
        a_MSRP: configure.a_MSRP,
        o_list_description: configure.o_list_description,
        o_qty: configure.o_qty,
        o_MSRP: configure.o_MSRP,
        dealer_discount: configure.dealerDiscount,
        adjusted_sales_price: configure.adjustedSalesPrice,
        destination_charge: configure.destinationCharge,
        description_additional_charges: configure.otherCostsDescription1 + " " + configure.otherCostsDescription2 + " " + configure.otherCostsDescription3 + " " + configure.otherCostsDescription4,
        additional_charges: configure.addedCosts,
        tax_percent: configure.tax_percent,
        tax: configure.summaryTax,
        doc_fee: configure.docFee,
        delivery: configure.delivery,
        down_payment: configure.downPayment,
        trade_in: configure.tradein,
        bank: configure.bank,
        term: configure.months,
        financing_description: configure.financingBestOption,
        total_financed: configure.totalPayments,
        total_cost: configure.totalBalanceDue,
        total_interest: configure.totalInterest,
        you_are_saving: configure.totalDiscounts,
        // itemsPrice: 

      })
    );
  };

  return (
    <div>
      <CheckoutSteps step1 step2 step3 step4 />
      <Row>
        <Col md={8}>
          <ListGroup variant="flush">
            {/* CUSTOMER INFO */}
            <ListGroup.Item>
              <h2>Customer Info</h2>
              <p>
                <strong>Name: </strong>
                {cart.shippingAddress.clientName}
              </p>
              <p>
                <strong>Email: </strong>
                <a href={`mailto:${cart.shippingAddress.clientEmail}`}>
                  {cart.shippingAddress.clientEmail}
                </a>
              </p>
              <p>
                <strong>Phone: </strong>
                {cart.shippingAddress.clientPhone}
              </p>
              <p>
                <strong>Address: </strong>
                {cart.shippingAddress.clientAddress},{" "}
                {cart.shippingAddress.clientCity},{" "}
                {cart.shippingAddress.clientState},{" "}
                {cart.shippingAddress.clientZip},{" "}
                {cart.shippingAddress.clientCountry}
              </p>
            </ListGroup.Item>
            {/* PROGRAMS SELECTED */}
            <ListGroup.Item>

              {cart.salesProgram.length === 0 ? (
                <Message variant="info">No programs selected</Message>
              ) : (
                <ListGroup 
                variant="flush mb-4"

                >
                  <Row>
                    {cart.salesProgram.map((program, index) => (
                      <Col key={index} 
                      md={12}
                      className="d-flex justify-content-center"
                      
                      >
                        <Card style={{ borderRadius: "20px" }}>
                          <Card.Header
                            style={{
                              backgroundColor: "#007bff",
                              color: "white",
                              fontWeight: "bold",
                              fontSize: "1.5rem",
                              textAlign: "center",
                              borderRadius: "20px 20px 0px 0px",
                            }}
                          >
                            {program.name}
                          </Card.Header>
                          <Card.Body
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",

                            }}
                          >
                            <Card.Text
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <span className="small">Dealer Discount: </span>
                              <span className="cardTextProfit price1 mb-4">
                                $
                                {parseFloat(configure.dealerDiscount).toLocaleString(
                                  undefined,
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                )}
                              </span>
                            </Card.Text>
                            <Card.Text
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                marginTop: "-30px",
                              }}
                            >
                              <span className="small">Savings:</span>
                              <span className="cardTextProfit price2">
                                $
                                {parseFloat(configure.totalDiscounts).toLocaleString(
                                  undefined,
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                )}
                              </span>
                            </Card.Text>
                            
                           
                            
                            <Card.Text
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                marginTop: "0px",
                              }}
                            >
                              <span className="small">Best Financing Option:</span>
                              <span 
                              style={
                                {
                                  fontSize: "1.1rem",
                                  fontWeight: "bold",
                                  color: "purple",
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  padding: "1rem",
                                  marginTop: "-10px",
                                }
                              }
                              >
                                {configure.financingBestOption}
                              </span>



                            </Card.Text>
                          </Card.Body>
                        </Card>
                      </Col>
                    ))}
                  </Row>
                </ListGroup>
              )}
            </ListGroup.Item>
            {/* QUOTE */}
            <ListGroup.Item>
              <h2>Quote</h2>
              {cartItems.length === 0 ? (
                <Message variant={"primary"}>
                  <p
                    style={{
                      fontSize: "2rem",
                      textAlign: "center",
                      padding: "50px",
                    }}
                  >
                    Your cart is empty{" "}
                  </p>{" "}
                </Message>
              ) : (
                <ListGroup variant="flush ">
                  {cartItems.map((item) => (
                    <ListGroup.Item key={item.product}>
                      <Row>
                        <Col md={3}>
                          <Image
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "contain",
                            }}
                            src={item.image}
                            alt={item.name}
                            fluid
                            rounded
                          />
                        </Col>
                        <Col md={8}>
                          <p className="attCartTitle">
                            {item.name} - {item.short_description}
                          </p>
                        </Col>

                        <Row md={2} className="cartRow">
                          <ListGroup>
                            <ListGroup.Item className="rounded">
                              {/* show attachments */}
                              {item.attachments &&
                              item.attachments.length > 0 ? (
                                <Table class="table table-hover">
                                  <span className="attCartDescription">
                                    Attachments:
                                  </span>
                                  <tbody>
                                    {item.attachments.map((attachment) => (
                                      <tr>
                                        <td className="attCartTitle">
                                          {attachment.name}
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </Table>
                              ) : (
                                <p>No attachments added</p>
                              )}
                            </ListGroup.Item>
                          </ListGroup>
                          <ListGroup>
                            <ListGroup.Item className="rounded">
                              {/* show options */}
                              {item.options && item.options.length > 0 ? (
                                <Table class="table table-hover">
                                  <span className="attCartDescription">
                                    Options:
                                  </span>
                                  <tbody>
                                    {item.options.map((option) => (
                                      <tr>
                                        <td className="attCartTitle">
                                          {option.name}
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </Table>
                              ) : (
                                <p>No options added</p>
                              )}
                            </ListGroup.Item>
                          </ListGroup>
                        </Row>
                      </Row>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              )}
            </ListGroup.Item>
          </ListGroup>
        </Col>
        {/* SUMMARY SECTION */}
        <Col md={4} className="order-md-2 mb-4">
          <h4 className="summaryTitle">Summary</h4>
          <ListGroup className="mb-3">
            <ListGroup.Item
              style={{
                borderRadius: "10px 10px 0px 0px",
              }}
            >
              <Row>
                <Col>Tractor:</Col>
                <Col>
                  <span className="price style1">
                    $
                    {parseFloat(
                      cartItems.reduce((acc, item) => acc + item.qty, 0) *
                        cartItems.reduce(
                          (acc, item) =>
                            acc +
                            item.tractors.reduce(
                              (acc, tractor) => acc + tractor.MSRP,
                              0
                            ),
                          0
                        )
                    ).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </span>
                </Col>
              </Row>
            </ListGroup.Item>

            <ListGroup.Item>
              <Row>
                <Col>Attachments:</Col>
                <Col>
                  <span className="price style1">
                    $
                    {cartItems
                      .reduce(
                        (acc, item) =>
                          acc +
                          item.attachments.reduce(
                            (acc, attachment) =>
                              acc + parseFloat(attachment.MSRP),
                            0
                          ),
                        0
                      )
                      .toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                  </span>
                </Col>
              </Row>
            </ListGroup.Item>

            <span></span>

            <ListGroup.Item>
              <Row>
                <Col>Options:</Col>
                <Col>
                  <span className="price style1">
                    $
                    {cartItems
                      .reduce(
                        (acc, item) =>
                          acc +
                          item.options.reduce(
                            (acc, option) => acc + parseFloat(option.MSRP),
                            0
                          ),
                        0
                      )
                      .toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                  </span>
                </Col>
              </Row>
            </ListGroup.Item>

            <span></span>

            <ListGroup.Item>
              <Row>
                <Col>
                  <strong>Total MSRP:</strong>
                </Col>
                <Col>
                  <span className="price style1">
                    $
                    {parseFloat(
                      // Tractors Total
                      cartItems.reduce(
                        (acc, item) =>
                          acc +
                          item.qty *
                            item.tractors.reduce(
                              (tractorAcc, tractor) =>
                                tractorAcc + tractor.MSRP,
                              0
                            ),
                        0
                      ) +
                        // Attachments Total
                        cartItems.reduce(
                          (acc, item) =>
                            acc +
                            item.attachments.reduce(
                              (attachmentAcc, attachment) =>
                                attachmentAcc + parseFloat(attachment.MSRP),
                              0
                            ),
                          0
                        ) +
                        // Options Total
                        cartItems.reduce(
                          (acc, item) =>
                            acc +
                            item.options.reduce(
                              (optionAcc, option) =>
                                optionAcc + parseFloat(option.MSRP),
                              0
                            ),
                          0
                        )
                    ).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </span>
                </Col>
              </Row>
            </ListGroup.Item>

            <span></span>
            <Col
              style={{
                fontWeight: "bold",
                backgroundColor: "#f0f0f0",
                color: "#999999",
                padding: "0.2rem",
                textAlign: "center",
              }}
            >
              Rebates
            </Col>
            <ListGroup.Item>
              <Row>
                <Col>Tractor Rebate:</Col>
                <Col>
                  <span className="price style1">
                    $
                    {parseFloat(configure.tractorRebate).toLocaleString(
                      undefined,
                      {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }
                    )}
                  </span>
                </Col>
              </Row>
            </ListGroup.Item>
            <ListGroup.Item>
              <Row>
                <Col>Loader Rebate:</Col>
                <Col>
                  <span className="price style1">
                    $
                    {parseFloat(configure.loaderRebate).toLocaleString(
                      undefined,
                      {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }
                    )}
                  </span>
                </Col>
              </Row>
            </ListGroup.Item>
            <ListGroup.Item>
              <Row>
                <Col>Other Rebate:</Col>
                <Col>
                  <span className="price style1">
                    $
                    {parseFloat(configure.otherRebate).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </span>
                </Col>
              </Row>
            </ListGroup.Item>
            <ListGroup.Item>
              <Row>
                <Col>Total Rebates:</Col>
                <Col>
                  <span className="price style1">
                    $
                    {parseFloat(configure.totalRebate).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </span>
                </Col>
              </Row>
            </ListGroup.Item>
            <Col
              style={{
                fontWeight: "bold",
                backgroundColor: "#f0f0f0",
                color: "#999999",
                padding: "0.2rem",
                textAlign: "center",
              }}
            >
              Additional Charges
            </Col>

            <ListGroup.Item>
              <Row>
                <Col>Set up & PDI:</Col>
                <Col>
                  <span className="price style1">
                    $
                    {parseFloat(configure.setupPDI).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </span>
                </Col>
              </Row>
            </ListGroup.Item>
            <ListGroup.Item>
              <Row>
                <Col>Destination Charge:</Col>
                <Col>
                  <span className="price style1">
                    $
                    {parseFloat(configure.destinationCharge).toLocaleString(
                      undefined,
                      {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }
                    )}
                  </span>
                </Col>
              </Row>
            </ListGroup.Item>
            <ListGroup.Item>
              <Row>
                <Col>Added Costs:</Col>
                <Col>
                  <span className="price style1">$
                  {parseFloat(configure.addedCosts).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                  }
                  </span>
                </Col>
              </Row>
            </ListGroup.Item>
            <ListGroup.Item>
              <Row>
                <Col>Total Additional Charges:</Col>
                <Col>
                  <span className="price style1">$
                  {parseFloat(configure.totalOtherCosts).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                  }
                  </span>
                </Col>
              </Row>
            </ListGroup.Item>
            <ListGroup.Item>
              <Row
                 style={{
                  backgroundColor: "#feffad",
                  borderRadius: "10px",
                }}
              
              >
                <Col>Adjusted Sales Price:</Col>
                <Col>
                  <span className="price style1">
                    $
                    {parseFloat(configure.adjustedSalesPrice).toLocaleString(
                      undefined,
                      {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }
                    )}
                  </span>
                </Col>
              </Row>
            </ListGroup.Item>
            
            <ListGroup.Item>
              <Row>
                <Col>State Tax (<strong>{parseFloat(cartAdjustments.tax) 
                .toLocaleString(undefined, {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                })}                
                %</strong>):</Col>
                <Col>
                  <span className="price style1">
                    $
                    {parseFloat(configure.summaryTax).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </span>
                </Col>
              </Row>
            </ListGroup.Item>
            <ListGroup.Item>
              <Row>
                <Col>Proc/Doc Fee:</Col>
                <Col>
                  <span className="price style1">
                    $
                    {parseFloat(configure.docFee).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </span>
                </Col>
              </Row>
            </ListGroup.Item>
            <ListGroup.Item>
              <Row>
                <Col>Delivery:</Col>
                <Col>
                  <span className="price style1">
                    $
                    {parseFloat(configure.delivery).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </span>
                </Col>
              </Row>
            </ListGroup.Item>
            <ListGroup.Item>
              <Row>
                <Col>Down Payment:</Col>
                <Col>
                  <span className="price style1">
                    $
                    {parseFloat(configure.downPayment).toLocaleString(
                      undefined,
                      {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }
                    )}
                  </span>
                </Col>
              </Row>
            </ListGroup.Item>
            <ListGroup.Item>
              <Row>
                <Col>Trade In:</Col>
                <Col>
                  <span className="price style1">
                    $
                    {parseFloat(configure.tradein).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </span>
                </Col>
              </Row>
            </ListGroup.Item>

            
            <ListGroup.Item
              style={{
                borderRadius: "0px 0px 10px 10px",
              }}
            >
              <Row
                style={{
                  backgroundColor: "#aef9b5",
                  borderRadius: "10px",
                }}
              >
                <Col
                  style={{
                    paddingTop: "0.5rem",
                    paddingBottom: "0.5rem",
                  }}
                >
                  <strong>Total Amount Due:</strong>
                </Col>
                <Col>
                  <span className="price style2">$
                  {parseFloat(configure.totalBalanceDue).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                  
                  </span>
                </Col>
              </Row>
            </ListGroup.Item>
          </ListGroup>
          <div className="py-5 text-center">
            <Button
              className="button adjust"
              type="submit"
              variant="primary"
              onClick={placeOrder}
            >
              Save Quote
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default PlaceQuoteScreen;
